import Vue from 'vue';
import axios from 'axios';
import store from './../store'
let v = new Vue();

function msg(str, type = "error") {
  v.$message({
    duration: 1000,
    message: str,
    type: type
  });
}

// 设置请求头 - token
axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.AuthorizationAdmin = token;
  }
  return config
})

// axios.interceptors.response.use(res => res, error => {
//   return Promise.reject(error.response.data);
// })
export default function ({
  type: type, //请求类型 不传就是get
  url: url,
  data: data,
  loading: loading, //是否开启loading提示
}) {
  let _param = arguments[0];
  if (_param.loading) {
    store.commit('setLoading', true);
  }
  if (!_param.type) { //get
    let _data = "?";
    for (let key in _param.data) {
      _data += `${key}=${_param.data[key] == undefined ? "" : _param.data[key]}&`
    }
    _param.url += _data;
    _param.url = _param.url.slice(0, -1);
    _param.data = "";
  }
  return new Promise((resolve, reject) => {
    axios({
      timeout: 20000,
      method: _param.type || "get",
      // url: store.state.url + _param.url, //线上用的接口地址
      url: `/api${_param.url}`, //本地开发用的
      data: _param.data || {}
    }).then(response => {
      if (_param.loading) {
        store.commit('setLoading', false);
      }
      if (response.data.code == -401) {// 返回 401 清除token信息并跳转到登录页面
        if (store.state.isOut) {
          return;
        }
        v.$alert('登录过期, 请重新登录', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            store.commit('setIsOut', true);
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("username");
            sessionStorage.removeItem("type");
            location.href = "/login";
          }
        });
        reject(response.data);
      } else {
        resolve(response.data);
      }
    }).catch(err => {
      if (_param.loading) {
        store.commit('setLoading', false);
      }
      if (err) {
        msg("与服务器通讯发生错误");
        reject(err);
      }
    })
  })
}